import { ISearchParams } from 'interfaces'
import { apiClientService, transformerService } from '.'
import { Key } from 'react'

const BASE_REGISTRY_URL = 'Anagrafiche/'

function getCities(setSuccess: (data: any) => void, setError?: (error: any) => void) {
  return apiClientService.baseApiCall(BASE_REGISTRY_URL + 'GetCitta', 'get', undefined, undefined, setSuccess, setError)
}
function getProfileTypes(setSuccess: (data: any) => void, setError?: (error: any) => void) {
  return apiClientService.baseApiCall(BASE_REGISTRY_URL + 'GetTipiProfili', 'get', undefined, undefined, setSuccess, setError)
}
function getProvince(setSuccess: (data: any) => void, setError?: (error: any) => void) {
  return apiClientService.baseApiCall(BASE_REGISTRY_URL + 'GetProvince', 'get', undefined, undefined, setSuccess, setError)
}
function getCitizenship(setSuccess: (data: any) => void, setError?: (error: any) => void) {
  return apiClientService.baseApiCall(BASE_REGISTRY_URL + 'GetStati', 'get', undefined, undefined, setSuccess, setError)
}
function getComuni(cityId: Key, setSuccess: (data: any) => void, setError?: (error: any) => void, searchParams?: ISearchParams) {
  return apiClientService.baseApiCall(
    BASE_REGISTRY_URL + 'GetComuni/' + cityId,
    'get',
    transformerService.fromISearchParamstoIBESearchParams(searchParams),
    undefined,
    setSuccess,
    setError,
  )
}

export const registryService = {
  getCities,
  getProfileTypes,
  getProvince,
  getCitizenship,
  getComuni,
}
